msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: eu\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-28 08:48\n"
"Last-Translator: \n"
"Language-Team: Basque\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: eu\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Babestua"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Bidalketak: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Azken bidalketa: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatizatua"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "Taldea"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Batak bestea"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Eskatuta"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "jarraitzen"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Jarraitzen dizu"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {jarraitzaile #} other {# jarraitzaile}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Egiaztatua"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "<0>{0}</0>(e)an batu zen"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Betiko"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Ezin da kontua kargatu."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Joan kontuaren orrira"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "jarraitzaile"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "bidalketa"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Gehiago"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0>(e)k adierazi du kontu berria duela:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Helbidea kopiatu da"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "Ezin da helbidea kopiatu"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Kopiatu helbidea"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Joan jatorrizko profilaren orrira"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Ikusi profileko irudia"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Ikusi profileko goiburuko irudia"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Erabiltzaileak informazio hau publiko ez egitea aukeratu du."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} bidalketa original, {1} erantzun, {2} bultzada"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Azken bidalketa azken egunean} other {Azken bidalketa azken {2} egunetan}}} other {{3, plural, one {Azken {4} bidalketak azken egunean} other {Azken {5} bidalketak azken {6} egunetan}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Azken bidalketa azken urte(et)an} other {Azken {1} bidalketak azken urte(et)an}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originalak"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Erantzunak"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Bultzadak"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Bidalketaren estatistikak ez daude erabilgarri."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Ikusi bidalketen estatistikak"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Azken bidalketa: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Mutututa"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Blokeatuta"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Ohar pribatua"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Aipatu <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Itzuli biografia"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Editatu ohar pribatua"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Gehitu ohar pribatua"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Jakinarazpenak gaitu dira @{username}(r)en bidalketetarako."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Jakinarazpenak ezgaitu dira @{username}(r)en bidalketetarako."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Ezgaitu jakinarazpenak"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Gaitu jakinarazpenak"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "@{username}(r)en bultzadak gaituta daude."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "@{username}(r)en bultzadak ezgaituta daude."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Ezgaitu bultzadak"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Gaitu bultzadak"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Gehitu zerrendara / kendu zerrendatik"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Esteka kopiatu da"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "Ezin da esteka kopiatu"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Kopiatu"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Ez dirudi partekatzea dabilenik."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Partekatu…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "@{username} mututzeari utzi zaio"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Utzi <0>@{username}</0> mututzeari"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Mututu <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "@{username} {0}rako mututu da"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "Ezin da @{username} mututu"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "<0>@{username}</0> jarraitzaileetatik kendu nahi?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} jarraitzaileetatik kendu da"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Kendu jarraitzailea…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "<0>@{username}</0> blokeatu nahi?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "@{username} blokeatzeari utzi zaio"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "@{username} blokeatu da"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "Ezin da @{username} blokeatzeari utzi"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "Ezin da @{username} blokeatu"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Utzi <0>@{username}</0> blokeatzeari"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Blokeatu <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Salatu <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Editatu profila"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Jarraipen-eskaera atzera bota?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "@{0} jarraitzeari utzi?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Utzi jarraitzeari…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Bota atzera…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Jarraitu"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Itxi"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Itzulitako biografia"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "Ezin da zerrendatik kendu."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "Ezin da zerrendara gehitu."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Ezin dira zerrendak kargatu."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "Zerrendarik ez."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Zerrenda berria"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "<0>@{0}</0>(r)i buruzko ohar pribatua"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "Ezin izan da ohar pribatua eguneratu."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Utzi"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Gorde eta itxi"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "Ezin da profila eguneratu."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Biografia"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Eremu gehigarriak"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Etiketa"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Edukia"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Gorde"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "erabiltzaile-izena"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "zerbitzariaren domeinu-izena"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Estalki modua ezgaituta"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Estalki modua gaituta"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Hasiera"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Idatzi"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Gorde gabeko aldaketak dituzu. Bidalketa zokoratu nahi duzu?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Fitxategi bakarra erantsi dezakezu.} other {# fitxategi erantsi ditzakezu gehienez.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Atera"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Ikonotu"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Badirudi leiho nagusia itxi duzula."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Badirudi dagoeneko baduzula editorea irekita leiho nagusian eta zerbait argitaratzen ari zarela. Itxaron bukatu arte eta saiatu berriro geroago."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Badirudi dagoeneko baduzula editorea irekita leiho nagusian. Leiho berri bat ateraz gero, leiho nagusian egindako aldaketak zokoratuko dira. Jarraitu nahi duzu?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Sartu"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "@{0}(r)en bidalketari erantzuten (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "@{0}(r)en bidalketari erantzuten"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Jatorrizko bidalketa editatzen"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "Bozketak 2 aukera izan behar ditu gutxienez"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Bozketaren aukeretako batzuk hutsik daude"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Ez dituzu multimedia fitxategi batzuk deskribatu. Jarraitu?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "#{i} eranskinak huts egin du"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "Edukiari buruzko abisua"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Edukiari buruzko abisua edo multimedia hunkigarria"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Publikoa"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Zerrendatu gabea"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Jarraitzaileentzat soilik"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Aipamen pribatua"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Argitaratu erantzuna"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Editatu bidalketa"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "Zertan zabiltza?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Markatu multimedia hunkigarri gisa"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Gehitu bozketa"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Gehitu emoji pertsonala"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Erantzun"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Eguneratu"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Argitaratu"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "GIFa deskargatzen…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Ezin da GIFa deskargatu"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Gehiago…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Igota"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Irudiaren deskribapena"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Bideoaren deskribapena"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Audioaren deskribapena"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Fitxategia handiegia da. Igoerak arazoak izan ditzake. Saiatu tamaina {0}tik {1} edo gutxiagora murrizten."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Neurria handiegia da. Igoerak arazoak izan ditzake. Saiatu neurria {0}×{1}px-etik {2}×{3}px edo gutxiagora murrizten."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Fotograma-tasa (frame rate) altuegia da. Igoerak arazoak izan ditzake."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Kendu"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Errorea"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Editatu irudiaren deskribapena"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Editatu bideoaren deskribapena"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Editatu audioaren deskribapena"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Deskribapena sortzen. Itxaron…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Ezin da deskribapena sortu: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Ezin da deskribapena sortu"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Sortu deskribapena…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Ezin iza da deskribapena sortu{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— esperimentala</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Eginda"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "{0}. aukera"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Hainbat aukera"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Iraupena"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Kendu bozketa"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Bilatu kontuak"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Gehitu"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Errorea kontuak kargatzean"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Instantziako emojiak"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Bilatu emojia"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Errorea emoji pertsonalizatua kargatzean"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Oraintsu erabilita"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Besteak"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} gehiago…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Bilatu GIFak"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "GIPHYri esker"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Idatzi GIFak bilatzeko"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "Aurrekoa"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "Hurrengoa"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Errorea GIFak kargatzean"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Bidali gabeko zirriborroak"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Badirudi bidali gabeko zirriborroak dituzula. Jarrai ezazu utzi zenuen tokian."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Zirriborroa ezabatu nahi duzu?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Errorea zirriborroa ezabatzean! Saiatu berriro."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Ezabatu…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Errorea erantzuten ari zaion egoera eskuratzean!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Zirriborro guztiak ezabatu?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Errorea zirriborroak ezabatzean! Saiatu berriro."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Ezabatu guztia…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Ez dago zirriborrorik."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "Bozketa"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Multimedia"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Ireki leiho berrian"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Onartu"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Ukatu"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Onartuta"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Ukatuta"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Ezertxo ere ez"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Kontuak"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Erakutsi gehiago…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Amaiera."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "Laster-teklak"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Teklatuko laster-teklen laguntza"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "Hurrengo bidalketa"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "Aurreko bidalketa"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Biratu karrusela hurrengora"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Biratu karrusela aurrekora"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Kargatu bidalketa berriak"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "Ireki bidalketaren xehetasunak"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> or <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Hedatu edukiaren abisua edo<0/>hedatu / tolestu haria"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Itxi bidalketa edo leihoa"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> or <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Fokatu zutabea zutabe anitzeko antolaketan"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> to <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Idatzi bidalketa berria"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Idatzi bidalketa berria (leiho berria)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Bidali"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Bilatu"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Erantzun (leiho berria)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Egin gogoko"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> edo <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Bultzatu"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Jarri laster-marka"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Estalki modua bai/ez"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Editatu zerrenda"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Ezin da zerrenda editatu."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Ezin da zerrenda sortu."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Izena"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Erakutsi zerrandako kideen erantzunak"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Erakutsi erantzunak jarraitzen diedan pertsonei"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Ez erakutsi erantzunik"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Ezkutatu Hasiera / Jarraitzen -etik zerrenda honetako bidalketak"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Sortu"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Zerrenda ezabatu nahi duzu?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Ezin da zerrenda ezabatu."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Fitxategiaren deskribapena"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Itzuli"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Irakurri ozenki"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Ireki jatorrizko multimedia fitxategia leiho berrian"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Ireki jatorrizko multimedia fitxategia"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Irudia deskribatzen saiatzen. Itxaron…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Ezin da irudia deskribatu"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Deskribatu irudia…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Ikusi bidalketa"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Multimedia fitxategi hunkigarria"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Iragazita: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "Iragazita"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Bidalketa argitaratu da. Ikus ezazu."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Erantzuna argitaratu da. Ikus ezazu."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Bidalketa eguneratu da. Ikus ezazu."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menua"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Birkargatu orria orain eguneratzeko?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Eguneraketa eskuragarri…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr "Zer berri?"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Aipamenak"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Jakinarazpenak"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Berria"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profila"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Zerrendak"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Zerrenda guztiak"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Laster-markak"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Gogokoak"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Jarraitutako traolak"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Iragazkiak"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Mutututako erabiltzaileak"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Mutututakoak…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Blokeatutako erabiltzaileak"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Blokeatutakoak…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Kontuak…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Hasi saioa"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Joerak"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Lokala"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federatua"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Laster-teklak / Zutabeak…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Ezarpenak…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Jakinarazpenak"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Jakinarazpena zure beste kontuarena da."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Ikusi jakinarazpen guztiak"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account}(e)k zure bidalketari {emojiObject}rekin erantzun dio"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account}(e)k bidalketa bat argitaratu du"

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)k zure erantzuna bultzatu du.} other {{account}(e)k zure bidalketa bultzatu du.}}} other {{account}(e)k zure {postsCount} bidalketa bultzatu ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> zure erantzuna bultzatu dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa bultzatu dute.}}}}"

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account}(e)k jarraitu dizu.} other {<0><1>{0}</1> pertsonak</0> jarraitu dizute.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account}(e)k jarraitzeko eskaera egin dizu."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)k zure erantzuna gogoko du.} other {{account}(e)k zure bidalketa gogoko du.}}} other {{account}(e)k zure {postsCount} bidalketa gogoko ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> zure erantzuna gogoko dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa gogoko dute.}}}}"

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Sortu edo boza eman zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "Sortu zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "Boza eman zenuen bozketa bat amaitu da."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Interaktuatu zenuen bidalketa bat editatu dute."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account}(e)ek zure erantzuna gogoko egin eta bultzatu du.} other {{account}(e)ek zure bidalketa gogoko egin eta bultzatu du.}}} other {{account}(e)k (e)ek zure  {postsCount} bidalketa gogoko egin eta bultzatu ditu.}}} other {{postType, select, reply {<0><1>{0}</1> pertsonak</0> erantzuna gogoko egin eta bultzatu dute.} other {<2><3>{1}</3> pertsonak</2> zure bidalketa gogoko egin eta bultzatu dute.}}}}"

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account}(e)k izena eman du."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account}(e)k {targetAccount} salatu du"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "<0>{name}</0>(r)ekin harremana galdu da."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Moderazio-ohartarazpena"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "<0>{from}</0>(e)ko administratzaile batek <1>{targetName}</1> bertan behera utzi du, eta horrek esan nahi du aurrerantzean ezingo duzula harekin harremanik izan."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "<0>{from}</0>(e)ko administratzaile batek <1>{targetName}</1> blokeatu du. Eragina du jarraitzen dizuten {followersCount} eta jarraitzen dituzun {followingCount} -engan."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "<0>{targetName}</0> blokeatu duzu. Jarraitzen zizuten {followersCount} eta jarraitzen zenituen {followingCount} kendu dira."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Zure kontuak moderazio-ohartarazpen bat jaso du."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Zure kontua ezgaitu da."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Zure bidalketa batzuk hunkigarri gisa markatu dira."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Zure bidalketa batzuk ezabatu dira."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "Aurrerantzean zure bidalketak hunkigarri gisa markatuko dira."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Zure kontuari mugak jarri zaizkio."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Zure kontua bertan behera utzi da."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Jakinarazpen mota ezezaguna: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Bultzatu/Gogoko du(te)…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Gogoko du…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Bultzatu du…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Jarraitzen dizu…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Ikasi gehiago <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Irakurri gehiago →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Bozkatu duzu"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Ezkutatu emaitzak"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Bozkatu"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Freskatu"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Erakutsi emaitzak"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {boto <0>{0}</0>} other {<1>{1}</1> boto}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {hautesle <0>{0}</0>} other {<1>{1}</1> hautesle}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "<0/>(e)an amaitu zen"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Amaitu da"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "<0/>(e)an amaituko da"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Amaiera-data"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Mezu baztergarria"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Esteka maltzurrak, gezurrezko elkarrekintzak edo erantzun errepikakorrak"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Legez kanpokoa"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Zure edo zerbitzariaren herrialdeko legedia urratzen du"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Zerbitzariaren arauen urraketa"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Zerbitzariaren arau jakinak urratzen ditu"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Urraketa"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Beste zerbait"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Arazoa ez dator bat beste kategoriekin"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Salatu bidalketa"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Salatu @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Berrikusketeke"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Bidalketa salatu da"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profila salatu da"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Ezin da bidalketa salatu"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Ezin da profila salatu"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Zein da bidalketaren arazoa?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Zein da profilaren arazoa?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informazio gehigarria"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Birbidali <0>{domain}</0>(e)ra"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Bidali salaketa"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "{username} mutututa"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Ezin da {username} mututu"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Bidali salaketa <0>+ Mututu profila</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} blokeatuta"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Ezin da {username} blokeatu"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Bidali salaketa <0>+ Blokeatu profila</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ kontuak, traolak eta bidalketak</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "<0>{query}</0> duten bidalketak"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "<0>#{0}</0>(r)ekin etiketatutako bidalketak"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Bilatu <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "<0>{query}</0> duten kontuak"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Hasiera / Jarraitzen"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Publikoa (Lokala / Federatua)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Kontua"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Traola"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Zerrendaren IDa"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Lokala bakarrik"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instantzia"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Aukerakoa, adib. mastodon.eus"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Bilatzeko terminoa"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Aukerakoa, zutabe anitzeko antolaketa erabili ezean"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "adib. PixelArt (5 gehienez, espazioen bidez bereizita)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Multimedia bakarrik"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Laster-teklak"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Zehaztu laster-teklen zerrenda bat honela agertzeko:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Botoi mugikorra"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Erlaitz- / Menu-barra"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Zutabe anitz"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "Ez dago erabilgarri uneko ikuspegian"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Mugitu gora"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Mugitu behera"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Editatu"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Gehitu laster-tekla / zutabe bat baino gehiago erabili ahal izateko."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "Oraindik ez dago zutaberik. Egin tap Gehitu zutabea botoian."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Oraindik ez dago laster-teklarik. Egin tap Gehitu laster-tekla botoian."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Ez dakizu zer gehitu?<0/>Probatu <1>Hasiera / Jarraitzen eta Jakinarazpenak</1>."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "{SHORTCUTS_LIMIT} zutabe gehienez"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "{SHORTCUTS_LIMIT} laster-tekla gehienez"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Inportatu / esportatu"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Gehitu zutabea…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Gehitu laster-tekla…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Zerrenda zehatza aukerakoa da. Zutabe anitzeko antolaketan zerrenda beharrezkoa da, bestela zutabea ez da erakutsiko."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Zutabe anitzeko antolaketan bilatzeko terminoa beharrezkoa da, bestela zutabea ez da erakutsiko."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Traola bat baino gehiago onartzen dira. Espazioen bidez bereizita."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Editatu laster-tekla"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Gehitu laster-tekla"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Denbora-lerroa"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Zerrenda"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Inportatu / Esportatu <0>Laster-teklak</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Inportatu"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Itsatsi laster-teklak hemen"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "Gordetako laster-teklak zerbitzaritik deskargatzen…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "Ezin dira laster-teklak deskargatu"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Deskargatu laster-teklak zerbitzaritik"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* Laster-tekla badago lehendik ere"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "Litekeena da zerrendak ezin erabiltzea beste kontu batekoak badira."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Ezarpenen formatu baliogabea"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "Gehitu uneko laster-teklei?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Uneko laster-tekletan ez daudenak gehituko dira soilik."

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "Ez dago inportatzeko laster-tekla berririk"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Laster-teklak inportatu dira. {SHORTCUTS_LIMIT} muga gainditu da, gainerakoak ez dira inportatuko."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Laster-teklak inportatu dira"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Inportatu eta gehitu…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "Uneko laster-teklak gainidatzi?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "Laster-teklak inportatu?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "edo gainidatzi…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Inportatu…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Esportatu"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "Laster-teklak kopiatu dira"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "Ezin dira laster-teklak kopiatu"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "Laster-teklen ezarpenak kopiatu dira"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "Ezin dira laster-teklen ezarpenak kopiatu"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Partekatu"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "Laster-teklak zerbitzarian gordetzen…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "Laster-teklak gorde dira"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "Ezin dira laster-teklak gorde"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Sinkronizatu zerbitzariarekin"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {karaktere #} other {# karaktere}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "Laster-teklen JSON gordina"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Inportatu / Esportatu ezarpenak zerbitzarira / zerbitzaritik (oso esperimentala)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/>(e)k <1>bultzatua</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Barka baina saioa hasita duzun zerbitzariak ezin du interaktuatu beste instantzia batekoa den bidalketa honekin."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "@{0}(r)en bidalketa gogoko izateari utzi diozu"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "@{0}(r)en bidalketa gogoko egin duzu"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "@{0}(r)en bidalketari laster-marka kendu diozu"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "@{0}(r)en bidalketari laster-marka jarri diozu"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Kendu bultzada"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Aipatu"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "Multimedia fitxategi batzuek ez dute deskribapenik."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Bidalketa zaharra (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "@{0}(r)en bidalketari bultzada kendu zaio"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "@{0}(r)en bidalketa bultzatu da/diozu"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Bultzatu…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "Utzi gogoko egiteari"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "Gogoko egin"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Kendu laster-marka"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Ikusi <0>@{0}</0>(r)en bidalketa"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Erakutsi edizio-historia"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Editatuta: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Txertatu bidalketa"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "Elkarrizketa mututzeari utzi zaio"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Elkarrizketa mututu da"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "Ezin da elkarrizketa mututzeari utzi"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "Ezin da elkarrizketa mututu"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Utzi elkarrizketa mututzeari"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Mututu elkarrizketa"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "Bidalketa profilean finkatzeari utzi zaio"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "Profilean finkatutako bidalketa"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "Ezin da bidalketa finkatzeari utzi"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "Ezin da bidalketa finkatu"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Utzi profilean finkatzeari"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Finkatu profilean"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "Bidalketa ezabatu nahi duzu?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Bidalketa ezabatu da"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "Ezin da bidalketa ezabatu"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Salatu bidalketa…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "Gogoko egina"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Bultzatua"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Laster-marka jarria"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Finkatua"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Ezabatua"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {erantzun #} other {# erantzun}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Haria{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Ezkutatu edukia"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Erakutsi edukia"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Erakutsi multimedia fitxategiak"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Editatuta"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Iruzkinak"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Edizio-historia"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "Ezin da historia kargatu"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Kargatzen…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "HTML kodea"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "HTML kodea kopiatu da"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "Ezin da HTML kodea kopiatu"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Multimedia eranskinak:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Kontuaren emojiak:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "URL estatikoa"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Emojiak:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Oharrak:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Hau estatikoa da, diseinurik eta scriptik gabekoa. Litekeena da zure estiloak aplikatu eta editatu behar izatea."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Bozketak ez dira interaktiboak, zerrendak bilakatzen dira boto-zenbaketan."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Multimedia eranskinak irudiak, bideoak, audioak edo edozein fitxategi mota izan daitezke."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "Bidalketa editatu edo ezabatu daiteke geroago."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Aurrebista"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Oharra: aurrebista honi estilo arin bat aplikatu zaio."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/>(e)k <1/> bultzatu du"

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Bidalketa berriak"

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Saiatu berriro"

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "Haria"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Iragazita</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "{sourceLangText} automatikoki itzultzen"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Itzultzen…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Itzuli {sourceLangText} (automatikoki antzemanda)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Itzuli {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Automatikoa ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Ezin da itzuli"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Jatorrizko egoera editatzen"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "@{0}(r)i erantzuten"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Orria itxi dezakezu."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Itxi leihoa"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Saioa hasi behar da."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Joan orri nagusira"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Kontuaren bidalketak"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Erantzunak)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Bultzadak)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Multimedia)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Garbitu iragazkiak"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Garbitu"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Erantzunak dituzten bidalketak erakusten"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Erantzunak"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Bultzadarik ez duten bidalketak erakusten"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Bultzadak"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Multimedia fitxategiak dituzten bidalketak erakusten"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "#{0} traola duten bidalketak erakusten"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "{0}(e)ko bidalketak erakusten"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Ez dago ikusteko ezer."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "Ezin dira bidalketak kargatu"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Ezin da kontuaren informazioa eskuratu"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Aldatu kontuko instantziara {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Aldatu nire instantziara (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Hilabetea"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Unean"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Lehenetsia"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Aldatu kontu honetara"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Aldatu fitxa / leiho berrian"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Ikusi profila…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Ezarri lehenetsi gisa"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "<0>@{0}</0> saioa amaitu nahi?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Amaitu saioa…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Gehitu lehendik dudan kontu bat"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Oharra: <0>Lehenetsitako</0> kontua erabiliko da beti hasieran. Gainerako kontuek saioa irekita mantendu bitartean iraungo dute."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Ezin dira laster-markak kargatu."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "azken orduko bidalketak"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "azken 2 ordutako bidalketak"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "azken 3 ordutako bidalketak"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "azken 4 ordutako bidalketak"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "azken 5 ordutako bidalketak"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "azken 6 ordutako bidalketak"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "azken 7 ordutako bidalketak"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "azken 8 ordutako bidalketak"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "azken 9 ordutako bidalketak"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "azken 10 ordutako bidalketak"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "azken 11 ordutako bidalketak"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "azken 12 ordutako bidalketak"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "12 ordu baino haratagoko bidalketak"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Jarraitutako traolak"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Taldeak"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "{selectedFilterCategory, select, all {Bidalketa guztiak} original {Bidalketa originalak} replies {Erantzunak} boosts {Bultzadak} followedTags {Jarraitutako traolak} groups {Taldeak} filtered {Iragazitako bidalketak}} erakusten, {sortBy, select, createdAt {{sortOrder, select, asc {zaharrena} desc {berriena}}} reblogsCount {{sortOrder, select, asc {bultzada gutxien dituena} desc {bultzada gehien dituena}}} favouritesCount {{sortOrder, select, asc {gogoko gutxien dituena} desc {gogoko gehien dituena}}} repliesCount {{sortOrder, select, asc {erantzun gutxien dituena} desc {erantzun gehien dituena}}} density {{sortOrder, select, asc {dentsitate txikiena duena} desc {dentsitate handiena duena}}}}ren arabera sailkatuta lehenengo{groupBy, select, account {, egilearen arabera aldekatuta} other {}}"

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr "Zer berri? <0>beta</0>"

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr "Laguntza"

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "Zer da hau?"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Zer berri? denbora-lerro bereizi bat da jarraitzen dituzunekin; goi-mailako ikuspegi bat eskaintzen du begirada batean, posta elektronikoan oinarritutako interfaze erraz batekin, mezuak ordenatzea eta iragaztea ahalbidetzen duena."

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr "Zer berri? interfazearen aurrebista"

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr "Jar gaitezen egunean"

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr "Jarri egunean jarraitzen diezunen bidalketekin."

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "Erakutsidazu…"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr "gehienez ere"

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr "Jarri egunean"

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr "Azken eguneraketarekin gainjartzen da"

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr "Azken eguneraketara arte ({0})"

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Oharra: litekeena da instantziak gehienez (gutxi gorabehera) 800 bidalketa erakustea hasierako denbora-lerroan, denbora tartea izaten dena izaten dela."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "Lehenago…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {bidalketa #} other {# bidalketa}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr "Eguneraketa kendu?"

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Oharra: gehienez 3 gordeko dira. Gainerakoak automatikoki kenduko dira."

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr "Bidalketak eskuratzen…"

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr "Litekeena da donbora behar izatea."

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr "Berrezarri iragazkiak"

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr "Gori-gorian dauden estekak"

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr "{0}(e)k partekatua"

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Guztia"

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {egile #} other {# egile}}"

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr "Sailkatu"

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr "Dentsitatea"

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr "Egileak"

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr "Bat ere ez"

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr "Erakutsi egile guztiak"

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr "Ez duzu zertan guztia irakurri."

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr "Hori da guztia."

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr "Itzuli gora"

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Jarraitzen dituzunek partekatutako estekak, partekatutako, bultzatutako eta gogoko egindako zenbakiagatik sailkatuta."

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr "Sailkatu: dentsitatea"

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Bidalketak informazioaren dentsitatearen edo sakoneraren arabera sailkatzen dira. Postu motzenak \"arinagoak\" dira, eta luzeenak, berriz, \"astunagoak\". Argazkidun bidalketak argazkirik gabekoak baino \"astunagoak\" dira."

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr "Taldekatu: egileak"

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Bidalketak egilearen arabera taldekatzen dira, egilearen bidalketen kopuruaren arabera sailkatuta."

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr "Hurrengo egilea"

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr "Aurreko egilea"

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr "Korritu gora"

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr "Iragazita: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Ezin dira gogokoak kargatu."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Hasiera eta zerrendak"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Denbora-lerro publikoak"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Elkarrizketak"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profilak"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Inoiz ez"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Iragazki berria"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {Iragazki #} other {# iragazki}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Ezin dira iragazkiak kargatu."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Oraindik ez dago iragazkirik."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Gehitu iragazkia"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Editatu iragazkia"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Ezin da iragazkia editatu"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Ezin da iragazkia sortu"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Izenburua"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Hitz osoa"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Ez dago hitz-gakorik."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Gehitu hitz-gakoa"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {hitz-gako #} other {# hitz-gako}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Iragazi…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Inplementatzeke"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Egoera: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Aldatu iraungitzea"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Iraungitzea"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Iragazitako bidalketak…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "txikituko dira"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "ezkutatuko dira"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Iragazkia ezabatu nahi duzu?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Ezin da iragazkia ezabatu."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Iraungi da"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "<0/>(e)an iraungiko da"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Ez da inoiz iraungiko"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {traola #} other {# traola}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Ezin dira jarraitutako traolak kargatu."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Oraindik ez duzu traolarik jarraitzen."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "Ez dago ikusteko ezer."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Ezin dira bidalketak kargatu."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (multimedia fitxategiak bakarrik) {instance}(e)n"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} {instance}(e)n"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (multimedia fitxategiak bakarrik)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Oraindik ez du inork traola hau erabili."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Ezin dira etiketa hau duten bidalketak kargatu"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} jarraitzeari utzi diozu"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "#{hashtag} jarraitzen ari zara"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Jarraitzen…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Utzi profilean nabarmentzeari"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Ezin da profilean nabarmentzen uzteari utzi"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Profilean nabarmentzen"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Nabarmendu profilean"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Gehienez # traola}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Gehitu traola"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Kendu traola"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Gehienezko # laster-teklara iritsi zara. Ezin da laster-tekla gehitu.} other {Gehienezko # laster-teklatara iritsi zara. Ezin da laster-tekla gehitu.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Laster-tekla badago lehendik ere"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Traolaren laster-tekla gehitu da"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Gehitu laster-tekletara"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Sartu instantzia berria, adib. \"mastodon.eus\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "Instantzia baliogabea"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Joan beste instantzia batera…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Joan nire instantziara (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "Ezin dira jakinarazpenak eskuratu."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<1>Jarraipen-eskaera</1> <0>berria</0>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "Ikusi guztia"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Ebazten…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Ezin da URLa ebatzi"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Oraindik ezer ez."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Kudeatu kideak"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "<0>@{0}</0> zerrendatik kendu nahi?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Kendu…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {zerrenda #} other {zerrenda #}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Oraindik ez dago zerrendarik."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr "Aplikazioa erregistratzeak huts egin du"

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "adib. \"mastodon.eus\""

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr "Ezin da saioa hasi. Saiatu berriro edo saiatu beste instantzia batean."

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "Jarraitu {selectedInstanceText}(r)ekin"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "Jarraitu"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "Oraindik ez duzu konturik? Sortu ezazu!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Aipamen pribatuak"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Pribatua"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Ez zaitu inork aipatu :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Ezin dira aipamenak kargatu."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "Jarraitzen ez ditudanenak"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Jarraitzen ez nautenenak"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "Kontu berria dutenenak"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr "Nik nahi gabe era pribatuan aipatu nautenenak"

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr "Zerbitzariko moderatzaileek muga jarri dietenak"

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Jakinarazpenen ezarpenak"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Jakinarazpen berriak"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Iragarpena} other {Iragarpenak}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "Jarraipen-eskaerak"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {Jarraipen-eskaera #} other {# jarraipen-eskaera}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Pertsona #en iragazitako jakinarazpenak} other {# pertsonaren iragazitako jakinarazpenak}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Aipamenak soilik"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Gaur"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "Zaharrak berri."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Atzo"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "Ezin dira jakinarazpenak kargatu"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "Jakinarazpenen ezarpenak eguneratu dira"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Ez erakutsi hauen jakinarazpenak:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Iragazi"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ez hartu kontuan"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "<0>{0}</0>(e)an eguneratu zen"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "Ikusi <0>@{0}</0>(r)en jakinarazpenak"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "<0>@{0}</0>(r)en jakinarazpenak"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Aurrerantzean ez dira @{0}(r)en jakinarazpenak iragaziko."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "Ezin da jakinarazpen-eskaera onartu"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Baimendu"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Aurrerantzean ez dira @{0}(r)en jakinarazpenak erakutsiko iragazitako jakinarazpenean."

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "Ezin da jakinarazpen-eskaera zokoratu"

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Baztertu"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "Baztertuta"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Denbora-lerro lokala ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Denbora-lerro federatua ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Denbora-lerro lokala"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Denbora-lerro federatua"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Oraindik inork ez du ezer argitaratu."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Aldatu federatura"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Aldatu lokalera"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Bilatu: {q} (Bidalketak)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Bilatu: {q} (Kontuak)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Bilatu: {q} (Traolak)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Bilatu: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Traolak"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Ikusi gehiago"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Ikusi kontu gehiago"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Ez da konturik aurkitu."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Ikusi traola gehiago"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Ez da traolarik aurkitu."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Ikusi bidalketa gehiago"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Ez da bidalketarik aurkitu."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Sartu bilatzeko terminoa edo itsatsi URLa gainean."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Ezarpenak"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Itxura"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Argia"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Iluna"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Automatikoa"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Testuaren tamaina"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "Pantaila-hizkuntza"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "Eskaini burua itzultzeko"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "Argitaratzean"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "Ikusgaitasuna, defektuz"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "Sinkronizatuta"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "Ezin da bidalketaren pribatutasuna eguneratu"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Zure zerbitzariko ezarpenekin sinkronizatu da. <0>Joan zure instantziara ({instance}) ezarpen gehiagorako.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "Esperimentuak"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "Automatikoki freskatu denbora-lerroko bidalketak"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "Bultzaden karrusela"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "Bidalketen itzulpena"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Itzuli…"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "Sistemak darabilena ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Ezkutatu \"Itzuli\" botoia honentzat:} other {Ezkutatu \"Itzuli\" botoia (#) hauentzat:}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Oharra: ezaugarri honek hirugarrenen itzulpen-zerbitzuak darabiltza, <0>Lingva API</0>k eta <1>Lingva Translate</1>k eskainiak."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "Itzulpen automatikoa bidalketan bertan"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Erakutsi automatikoki bidalketen itzulpena denbora-lerroaren baitan. Bidalketa <0>labur</0>retarako balio du bakarrik, eta ezin dute edukiari buruzko oharrik, multimedia fitxategirik edo bozketarik izan."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "GIF hautatzailea"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Oharra: ezaugarri honek hirugarrenen zerbitzua darabil GIFen bilaketarako, <0>GIPHY</0>k eskainia. Adin guztietarako egokia da, jarraipen parametroak ezabatu egiten dira, jatorriaren informazioa eskarietatik kanpo uzten da, baina bilaketa-kontsultek eta IP helbidearen informazioak bere zerbitzarietara iristen jarraituko dute."

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Irudien deskribapen-sortzailea"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "Soilik irudi berrientzat bidalketa berriak idaztean."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Oharra: ezaugarri honek hirugarrenen AA zerbitzua darabil, <0>img-alt-api</0>k eskainia. Litekeena da erabat ondo ez egitea. Soilik irudientzat eta soilik ingelesez."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "Zerbitzariak taldekatutako jakinarazpenak"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Alpha fasean dagoen ezaugarria. Taldekatzea hobetu lezake, baina oinarrizko logika erabiliz."

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Laster-teklen hodeiko inportazio / esportazio ezarpenak"

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Oso esperimentala.<0/>Zure profileko oharretan gordetzen da. Profileko oharrak (pribatuak) beste profil batzuei buruzko oharretarako erabiltzen dira nagusiki, eta norberaren profilean ezkutatuta daude."

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Oharra: ezaugarri honek saio hasita duzun zerbitzariaren APIa darabil."

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Eskalki modua <0>(<1>Testua</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Testua blokeekin ordezkatzen du, pantaila-argazkiak egitean aproposa pribatutasun arrazoiengatik."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "Honi buruz"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<1>@cheeaun</1>ek <0>sortua</0>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "Babestu"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Egin dohaintza"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Pribatutasun politika"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>Gunea:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Bertsioa:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "Bertsioaren haria kopiatuta"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "Ezin da bertsioaren haria kopiatu"

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "Ezin da harpidetza eguneratu. Saiatu berriro."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr "Ezin da harpidetza kendu. Saiatu berriro."

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Push jakinarazpenak (beta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Push jakinarazpenak blokeatuta daude. Gaitu itzazu nabigatzaileko ezarpenetan."

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "Baimendu <0>{0}</0>(r)en"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "edonor"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "jarraitzen dudan jendea"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "jarraitzaile"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "Jarraitzen die"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Bozketak"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "Bidalketen edizioak"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Ez da push baimenik eman saioa azkenekoz hasi zenuenetik. <0><1>Hasi saioa</1> berriro baimentzeko</0>."

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "Oharra: push jakinarazpenak <0>kontu bakarrarentzat</0> dabiltza."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Argitaratu"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Ez duzu saiorik hasi. Ezin duzu interaktuatu (erantzun, bultzatu...)"

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Bidalketa hau beste instantzia batekoa da (<0>{instance}</0>). Interakzioak (erantzunak, bultzadak, etab.) ez dira posible."

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Errorea: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr "Aldatu nire instantziara interakzioak gaitzeko"

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "Ezin dira erantzunak kargatu."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Atzera"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "Joan bidalketa nagusira"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr "{0} bidalketa goian ‒ Joan gora"

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr "Aldatu gainbegirada bistara"

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr "Aldatu bista osora"

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr "Erakutsi eduki hunkigarri guztia"

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Esperimentala"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "Ezin da aldatu"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "Aldatu bidalketaren instantziara ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "Aldatu bidalketaren instantziara"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "Ezin da bidalketa kargatu"

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {erantzun #} other {<0>{1}</0> erantzun}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {iruzkin #} other {<0>{0}</0> iruzkin}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "Ikusi bidalketa eta erantzunak"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "Joerak ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Pil-pilean dauden albisteak"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "Itzuli bogan dauden bidalketetara"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "<0>{0}</0> aipatzen duten bidalketak erakusten"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "Bogan dauden bidalketak"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "Ez dago bogadn dagoen joerarik."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Mastodon erabiltzeko web-bezero minimalista eta aparta."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Hasi saioa Mastodon-ekin"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Eman izena"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Konektatu zure Mastodon / Fedibertsoko kontua.<0/>Zure egiaztagiriak ez dira zerbitzari honetan gordetzen."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<1>@cheeaun</1>ek <0>sortua</0>. <2>Pribatutasun politika</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Bultzaden karruselaren pantaila-argazkia"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Bultzaden karrusela"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Bereizi bisualki bidalketa originalak eta partekatutakoak (bultzadak)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Habiratutako iruzkinen hariaren pantaila-argazkia"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Habiratutako iruzkinen haria"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Jarraitu elkarrizketak arazorik gabe. Erantzunak tolesten dira."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Taldekatutako jakinarazpenen pantaila-argazkia"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Taldekatutako jakinarazpenak"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Antzeko jakinarazpenak taldekatzen eta tolesten dira anabasa gutxitzeko."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Zutabe anitzeko interfazearen pantaila-argazkia"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Nahi beste zutabe"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Defektuz, zutabe bakarra ZEN antolaketa nahi dutenentzako. Zutabe gehiago konfiguratu daitezke erabilera aurreraturako."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Traola anitzeko denbora-lerroaren pantaila-argazkia, traola gehiago gehitzeko inprimakiarekin"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Traola anitzeko denbora-lerroa"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Denbora-lerro bakarrean 5 traola ere batu daitezke."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Badirudi nabigatzailea laster-leihoak blokeatzen ari dela."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Zirriborro bat ikonotuta dago. Argitaratu edo zokoratu berri bat sortu baino lehen."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Bidalketa bat irekita dago. Argitaratu edo zokoratu berri bat sortu baino lehen."

